import { useMemo } from "react";

import { createNumberFormat, normalizeCurrency } from "src/lib/format";

/** Bind labels to the store that owns the data, without changing billing formatters. */
export const useNumberFormat = (currency) => {
  const code = normalizeCurrency(currency);
  return useMemo(() => createNumberFormat(code), [code]);
};
